var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import i18next from '../../strings/i18n/i18n';
import { IMAGE_ASSET_PATHS } from '../../const/alertsConfig';
import SyfStorage from '../../helpers/SyfStorage';
import alertsTriggerAnalyticsEvent, { analyticsHelper } from '../../helpers/analyticsMiddleware';
import { AlertsNotAvailableInfoWrapper, InfoBodyWrapper, InfoContentWrapper, InfoImageWrapper, InfoImg, InfoTitleWrapper } from './subcomponents';
var AlertsNotAvailableInfo = function (_a) {
    var _b;
    var analyticsAccountInfoMessage = _a.analyticsAccountInfoMessage, clientId = _a.clientId, isPageLoaded = _a.isPageLoaded, mfeConfig = _a.mfeConfig, platform = _a.platform;
    var alertsNotAvailableTitle = "".concat(i18next.t('alertsNotAvailableInfo.title'));
    var alertsNotAvailableMessage = "".concat(i18next.t('alertsNotAvailableInfo.content'));
    var currentLanguage = "us|".concat(SyfStorage.getLanguage());
    var ASSET_HOST = (_b = mfeConfig === null || mfeConfig === void 0 ? void 0 : mfeConfig.hosts) === null || _b === void 0 ? void 0 : _b.assets;
    useEffect(function () {
        if (isPageLoaded) {
            var _a = analyticsHelper.pageEvents.NOT_AVAILABLE, PAGE_FUNCTION = _a.PAGE_FUNCTION, NAME = _a.NAME, PAGE_KIND = _a.PAGE_KIND;
            var siteIdentifier = analyticsHelper.siteIdentifier[platform];
            var pnl = analyticsHelper.pnl[platform];
            alertsTriggerAnalyticsEvent({
                clientName: clientId,
                message: analyticsAccountInfoMessage,
                countryLanguage: currentLanguage,
                token: SyfStorage.getCorrelationId(),
                pageFunction: PAGE_FUNCTION,
                pageName: NAME,
                pageKind: PAGE_KIND,
                messageType: "".concat(alertsNotAvailableMessage),
                siteIdentifier: siteIdentifier,
                pnl: pnl,
                previouslyVisited: ''
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentLanguage, isPageLoaded, analyticsAccountInfoMessage, platform]);
    return (_jsxs(AlertsNotAvailableInfoWrapper, __assign({ "data-test": "AlertsNotAvailableInfo" }, { children: [_jsx(InfoImageWrapper, __assign({ "data-test": "InfoImageWrapper" }, { children: _jsx(InfoImg, { src: "".concat(ASSET_HOST).concat(IMAGE_ASSET_PATHS.ALERT_NOT_FOUND), alt: "alerts not available" }) })), _jsxs(InfoContentWrapper, __assign({ "data-test": "InfoContentWrapper" }, { children: [_jsx(InfoTitleWrapper, __assign({ id: "InfoTitle", "data-test": "InfoTitleWrapper" }, { children: alertsNotAvailableTitle })), _jsx(InfoBodyWrapper, __assign({ id: "infoBody", "data-test": "InfoBodyWrapper" }, { children: alertsNotAvailableMessage }))] }))] })));
};
export default AlertsNotAvailableInfo;
